
document.addEventListener('DOMContentLoaded', function () {
  

 const images = document.querySelectorAll(
  '.multicolumn .multicolumn-card__image'
); 

  if (!images.length) return;

  const lightbox = document.createElement('div');
  lightbox.className = 'sorigem-lightbox';
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', 'Jewelry photo');

  lightbox.innerHTML = `
    <button class="sorigem-lightbox-close"
            type="button"
            aria-label="Close image">×</button>
   
<button class="sorigem-lightbox-prev" type="button" aria-label="Previous image">&#10094;</button>
<img alt="">
<button class="sorigem-lightbox-next" type="button" aria-label="Next image">&#10095;</button>

  `;

  document.body.appendChild(lightbox);

  const enlargedImage = lightbox.querySelector('img');
  const closeButton = lightbox.querySelector('button');
  let previousFocus = null;
const prevButton = lightbox.querySelector('.sorigem-lightbox-prev');
const nextButton = lightbox.querySelector('.sorigem-lightbox-next');

let currentIndex = 0;

function showImage(index) {
  currentIndex = (index + images.length) % images.length;

  const img = images[currentIndex];
  const url = new URL(img.currentSrc || img.src, location.href);
  url.searchParams.set('width', '2000');

  enlargedImage.src = url.toString();
  enlargedImage.alt = img.alt || 'SoriGem jewelry';
}

prevButton.addEventListener('click', function () {
  showImage(currentIndex - 1);
});

nextButton.addEventListener('click', function () {
  showImage(currentIndex + 1);
});


  function closeLightbox() {
    lightbox.classList.remove('is-open');
    enlargedImage.removeAttribute('src');
    if (previousFocus) previousFocus.focus();
  }

  images.forEach(function (img) {
    img.style.cursor = 'zoom-in';
    img.setAttribute('tabindex', '0');
    img.setAttribute('role', 'button');
    img.setAttribute('aria-label', 'Enlarge jewelry photo');

    function openImage() {
      previousFocus = document.activeElement;
      currentIndex = Array.from(images).indexOf(img);

      showImage(currentIndex);
      lightbox.classList.add('is-open');
      closeButton.focus();
    }

    img.addEventListener('click', openImage);
    img.addEventListener('keydown', function (event) {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        openImage();
      }
    });
  });

  closeButton.addEventListener('click', closeLightbox);

  lightbox.addEventListener('click', function (event) {
    if (event.target === lightbox) closeLightbox();
  });

  document.addEventListener('keydown', function (event) {
    if (!lightbox.classList.contains('is-open')) return;

    if (event.key === 'Escape') {
      closeLightbox();
    }
  });
});
